export default {
	tenantId: "liberty_uat",
	appId: "covergo_crm",
	fileSystem: {
		bucketName: "liberty--uat"
	}
}
